module.exports = __webpack_public_path__ + "static/media/Iterative_Design_Final.44a6761e.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdfs/Iterative_Design_Final.pdf
// module id = 399
// module chunks = 1